import {useEffect} from 'react';
import API from '../../API';
import Ad from '../../layout/Ad';
import {useDispatch} from 'react-redux';
import {getProfilePictureURL} from '../../util/userUtil';
import {formatCount} from '../../util/formatUtil';
import Head from 'next/head';
import Link from 'next/link';
import Error from '../../components/Error';
import {I18nText} from '../../i18n/I18nText';
import {useI18NStringProvider} from '../../i18n/i18n';
import {useApplyAdsenseWhenPageLoaded} from '../../util/applyAdsenseWhenPageLoaded';

export default function Index({models, error}) {
    const dispatch = useDispatch();
    const i18n = useI18NStringProvider();
    useApplyAdsenseWhenPageLoaded();

    useEffect(() => {
        dispatch({type: 'navbar:setActiveCategory', val: 'cornstars'});
    }, []);

    if (error) {
        return <Error error={error}/>;
    }

    return <div className="p-3 max-w-1300px m-auto">
        <Head>
            <title>{`${i18n('model.html_title')} - CornHub`}</title>
        </Head>

        <div className="md:flex">
            <div className="p-3 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 w-full h-max">
                {models.map((model) => {
                    const views = model.videos.reduce((a, video) => a + video.views, 0);

                    return <Link href={`/model/${model.username}`} key={model.id}>
                        <div
                            className="w-full aspect-square bg-no-repeat bg-contain"
                            style={{
                                backgroundImage: `url(${getProfilePictureURL(model)})`,
                                backgroundPosition: '50% 50%'
                            }}/>
                        <h2 className="text-xl font-bold">{model.display_name ?? model.username}</h2>
                        <h3 className="text-slate-400">
                            <I18nText
                                id={model.video_count !== 1 ? 'model.video_count.plural' : 'model.video_count.single'}
                                placeholders={{count: formatCount(model.video_count)}}/>
                            &nbsp;
                            <I18nText id={views !== 1 ? 'video.view_count.plural' : 'video.view_count.single'}
                                      placeholders={{count: formatCount(views)}}/>
                        </h3>
                    </Link>;
                })}
                <div className="overflow-hidden max-h-[100%] min-w-[250px]">
                    <div className="min-w-[250px]">
                        <ins className="adsbygoogle"
                             style={{display: 'block'}}
                             data-ad-format="fluid"
                             data-ad-layout-key="-85+eb+2i-23-3c"
                             data-ad-client="ca-pub-1284128935095137"
                             data-ad-slot="7642213883"></ins>
                    </div>
                </div>
            </div>
            <div className="w-max md:pl-10 md:pr-10 m-auto">
                <Ad orientation="square" page="models" position="besides-models"/>
                <Ad orientation="square" page="models" position="besides-models" housePlease={true}/>
            </div>
        </div>

        <div className="mt-10">
            <Ad orientation="horizontal" page="models" position="below-models"/>
        </div>
    </div>;
}

Index.getInitialProps = async ({req, res = {}}) => {
    const {data, errored} = await API.get('/user', {req});

    if (errored) {
        res.statusCode = 503;
        return {error: {status: 503}};
    }

    return {models: data};
}
